import { render, staticRenderFns } from "./serve-meals.vue?vue&type=template&id=7510478f"
import script from "./serve-meals.vue?vue&type=script&lang=ts"
export * from "./serve-meals.vue?vue&type=script&lang=ts"
import style0 from "./serve-meals.vue?vue&type=style&index=0&id=7510478f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports